import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'languages',
  pure: true
})
@Injectable()
export class languagesPipe implements PipeTransform {
  transform(value: any, args?: any[]): any[] {
    let languages = {
      es: 'Español',
      en: 'Inglés',
      ca: 'Catalán',
    }

    return languages[value] || false;
  }
}
// end file



// WEBPACK FOOTER //
// ./src/pipes/languages.ts